
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","width":"1em","height":"1em","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.83 0a3.337 3.337 0 013.333 3.17l.004.167V10a.833.833 0 01-1.662.097L17.5 10V3.337a1.67 1.67 0 00-1.545-1.666l-.125-.004H3.337A1.67 1.67 0 001.67 3.212l-.004.125v13.33c0 .878.68 1.598 1.542 1.662l.124.004H10a.833.833 0 01.097 1.661L10 20H3.333a3.333 3.333 0 01-3.329-3.167L0 16.667V3.336A3.337 3.337 0 013.17.004L3.337 0H15.83zM15 11.667a3.333 3.333 0 012.872 5.027l1.884 1.883a.833.833 0 01-1.1 1.248l-.079-.07-1.884-1.883A3.333 3.333 0 1115 11.667zm-7.049.966c.36.231.481.692.297 1.067l-.047.084-1.81 2.81a.833.833 0 01-1.115.271l-.085-.056-1.524-1.142a.833.833 0 01.912-1.391l.087.057.808.605L6.8 12.882a.833.833 0 011.152-.25zm7.049.7a1.666 1.666 0 100 3.333 1.666 1.666 0 000-3.333zm-7.049-5.7c.36.231.481.692.297 1.067l-.047.084-1.81 2.81a.833.833 0 01-1.115.271l-.085-.056-1.524-1.142a.833.833 0 01.912-1.391l.087.057.808.605L6.8 7.882a.833.833 0 011.152-.25zM15 9.167a.833.833 0 01.097 1.66l-.097.006h-5a.833.833 0 01-.097-1.66L10 9.166h5zM7.95 2.633c.36.231.481.692.297 1.067l-.047.085-1.81 2.809a.833.833 0 01-1.115.271l-.085-.056-1.524-1.142a.833.833 0 01.912-1.391l.087.057.808.605L6.8 2.882a.833.833 0 011.152-.25zM15 4.167a.833.833 0 01.097 1.66L15 5.834h-5a.833.833 0 01-.097-1.66L10 4.166h5z"}})])
          )
        }
      }
    